import { useMutation } from '@tanstack/react-query';
import { put } from '@/shared/api/api-client';

export interface ChangePasswordRequest {
  userId: string;
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

/**
 * PUT /api/identity-server/Account/ChangePassword/{userId}
 * Powers the Password section of Account Details (PROD-755).
 *
 * Flutter hits this via `identityAPI(IdentityService.Account)` — the path
 * lands on the identity server, not the main API. The dev Vite proxy
 * already routes `/api/*` to backend; if the identity server is mounted
 * separately, backend will need to expose it under this prefix or we
 * switch to an absolute URL.
 */
export function useChangePassword() {
  return useMutation({
    mutationFn: ({ userId, currentPassword, newPassword, confirmPassword }: ChangePasswordRequest) =>
      put<unknown>(`/api/identity-server/Account/ChangePassword/${userId}`, {
        currentPassword,
        newPassword,
        confirmPassword,
      }),
  });
}
